import React, { Fragment } from 'react'
import { useHistory, withRouter } from "react-router";
import { Link } from "react-router-dom";
import filter from 'ramda/src/filter'
import pipe from 'ramda/src/pipe'
import { Table, Button, Input, Space, PageHeader, message } from 'antd'
import {
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import { sdkIosAttributes, sdkIosAttribute } from 'src/data'
import Services from 'src/services'
import { useRadioButton, useRequest } from 'src/hooks';
import { ConfirmPop } from '../ConfirmPop';
import { mapColumn, compareBy } from 'src/utils';

export const Ios = withRouter(function({title}: any) {
    const [loading, setLoading] = React.useState(false)
    const [version, setVersion] = React.useState<string>('')
    const history = useHistory()
    const editLink = (id: string) => '/sdk_editor/ios/' + id

    const onCell = (record: any) => {
        return {
            onClick: (event: any) => {
                history.push(editLink(record.id))
            }
        };
    }
    const addOnCell = (column: any) => ({ ...column, onCell, className: 'ant-table-pointer' })
    const makeColumn = pipe(mapColumn, addOnCell)
    const columns = [
        {
            width: 200,
            ...makeColumn(sdkIosAttribute.versionName),
            sorter: {
                compare: compareBy('versionName'),
                multiple: 1,
            },
            ellipsis: true,
        },
        {
            title: '',
            key: 'x',
            width: 140,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={`/network/ios?sdk_id=${props?.id}&sdk_version=${props?.versionName}`}>
                            <Button icon={<UnorderedListOutlined />}>广告网络</Button>
                        </Link>
                    </Fragment>
                )
            }
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     width: 20,
        //     key: 'id',
        // }, 
        {
            ...addOnCell(sdkIosAttribute.enabled),
            render(props: any) {
                let state = (sdkIosAttribute.enabled.values as Array<any>).find((enabled: any) => enabled.key === props.enabled.toString())
                if(state.key === '0') {
                    return
                }

                if(props.isLoaded === '0') {
                    return <span style={{color: '#b99f1c'}}>发布中</span>
                } else if (props.isLoaded === '2') {
                    return <span style={{color: '#ff4d4f'}}>发布失败！Git Tag不存在！</span>
                }
                
                return <span>{state.title}</span>
            }
        },
        // ...sdkIosAttributes
        //     .filter((column: any) => !column.hideInList)
        //     .map(mapColumn)
        //     .map(addOnCell)
        //     ,
        {
            title: '操作',
            key: 'x',
            width: 140,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={editLink(props?.id)}>
                            <Button type="text" icon={<EditOutlined />} />
                        </Link>
                        <Link to={'/sdk_editor/ios/copy/' + props?.id}>
                            <Button type="text" icon={<CopyOutlined />} />
                        </Link>
                        <ConfirmPop
                            onOk={handleDelete(props?.id)}
                            title='确认删除'
                        >
                            <Button icon={<DeleteOutlined />} type="text" danger />
                        </ConfirmPop>
                    </Fragment>
                )
            }
        },
    ]

    const requestDelete = useRequest(Services.iosSdk.delete)
    const handleDelete = (id: any) => () => {
        return requestDelete({sdkId: id})
            .then((res: any) => {
                message.success('删除成功')
                fetchList()
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const [dataSource, setDataSource] = React.useState<any>([])

    const requestList = useRequest(Services.iosSdk.list)
    const fetchList = () => {
        setLoading(true)
        requestList()
            .then(setDataSource)
            .finally(() => setLoading(false))
    }
    React.useEffect(() => {
        fetchList()
    }, [])

    const [PublishRadio, isPublish]: any = useRadioButton({
        options: [
            {label: '不限', value: ''},
            {label: '已发布', value: '1'},
            {label: '未发布', value: '0'},
        ]
    })

    const filterDataSource = pipe(
        filter((item: any) => !!~item.versionName.indexOf(version)),
        filter((item: any) => {
            if(isPublish === '') {
                return true
            }else if(isPublish === '1') {
                return item?.enabled.toString() === '1'
            } else {
                return item?.enabled.toString() === '0'
            }
        })

    ) 

    return <div>
        <PageHeader title={title} />

        <Space align="center" style={{marginBottom: '10px'}} wrap>
            <Link to={'/sdk_editor/ios'}>
                <Button type="primary">
                    添加版本
                </Button>
            </Link>

            <Input onChange={e => setVersion(e.target.value)} placeholder="SDK版本号" />
            <PublishRadio />
        </Space>
        
        <Table 
            rowKey="id"
            size="small"
            dataSource={filterDataSource(dataSource) as object[]} 
            columns={columns}
            loading={loading}
            pagination={{
                pageSize: 50
            }}
            expandable={{
                expandedRowRender: (record: any) => {
                    return (
                        <Fragment>
                            {
                                sdkIosAttributes
                                    .filter((column: any) => !!column.hideInList)
                                    .map((column: any) => (
                                        <Fragment key={column.key}>
                                            <h3 className="m0">{column.title}</h3>
                                            {
                                                record[column.key]?.split(/\n/).map((s: any) => 
                                                    <p className="m0" key={column.key + '_'}>{s}</p>
                                                )
                                            }
                                            <br />
                                        </Fragment>
                                    ))
                            }
                        </Fragment>
                    )
                },
                rowExpandable: (record: any) => record.name !== 'Not Expandable',
            }}
        />
    </div>
})